import { AdminPage } from "./AdminPage";
import { LoginPage } from "./LoginPage";

export function App() {
  if (window.location.pathname === "/login") return <LoginPage />;
  if (window.location.pathname.startsWith("/admin")) return <AdminPage />;
  return <LoginPage />;
}
